import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";

export default function DynamicLinks() {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState({});

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/course-categories`
      );
      const categoriesData = response.data.categories || [];
      setCategories(categoriesData);

      const allData = {};
      await Promise.all(
        categoriesData.map(async (category) => {
          try {
            const res = await axios.get(
              `${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/program?category=${category}`
            );
            allData[category] = res.data || [];
          } catch (error) {
            console.error(`Error fetching courses for ${category}:`, error);
          }
        })
      );
      setData(allData);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  return (
    <div>
      <span className="text-2xl sm:text-3xl font-semibold">Programs</span>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
        {categories.map((category, index) => (
          <div key={index} className="w-full">
            <h2 className="text-lg sm:text-xl font-medium mb-2">{category}</h2>
            {data[category] && data[category].length > 0 ? (
              <div className="space-y-1">
                {data[category].slice(0, 5).map((course, idx) => (
                  <Link
                    key={idx}
                    to={`/program/${course.programId}`}
                    className="footer-links hover:underline block text-sm sm:text-base"
                  >
                    {course.universityName} | {course.programName}
                  </Link>
                ))}
              </div>
            ) : (
              <p className="text-sm opacity-70">No programs available</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
